import { useState, useEffect } from "react";
import { firestore } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import "../../styles/viewplacementimage.css";

const ViewPlacementImage = () => {
  const [slides, setSlides] = useState([]);
  const navigate = useNavigate();
  const collegeLogo = "/images/poly.png";

  useEffect(() => {
    const fetchAllSlides = async () => {
      try {
        // Get all documents from the "169" collection
        const querySnapshot = await getDocs(collection(firestore, "169"));
        
        console.log("Documents found:", querySnapshot.size);
        
        if (querySnapshot.empty) {
          console.log("No slides found in the 169 collection");
        } else {
          // Map through documents and extract all slide data
          const slidesData = [];
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            slidesData.push({
              id: doc.id,
              ...data,
              order: data.displayOrder ?? 999999
            });
            console.log("Found slide:", doc.id, "Order:", data.displayOrder, "Type:", data.type);
          });
          
          // Sort slides by displayOrder (ascending)
          const sortedSlides = slidesData.sort((a, b) => a.order - b.order);
          
          setSlides(sortedSlides);
          console.log("Total slides fetched:", sortedSlides.length);
          console.log("Slides sorted by display order");
        }
      } catch (error) {
        console.error("Error fetching slides from Firestore:", error);
      }
    };

    fetchAllSlides();
  }, []);

  return (
    <div className="placement-slider">
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={10}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        className="image-slider"
      >
        {slides.length > 0 ? (
          slides.map((slide, index) => {
            console.log("Rendering slide:", slide.id, "Type:", slide.type, "Has imageUrl:", !!slide.imageUrl);
            
            // Render college slide with overlay
            if (slide.isHardcoded && slide.type === "college") {
              return (
                <SwiperSlide key={slide.id} className="full-screen-slide">
                  <div className="overlay-container">
                    <img 
                      src={slide.imagePath} 
                      alt={slide.id === "college-slide-1" ? "College View" : "College Drone View"} 
                      className="full-screen-image" 
                    />
                    <div className="marquee-container">
                      <div className="marquee-text">
                        <img src={collegeLogo} alt="Logo" className="marquee-logo" />
                        {slide.id === "college-slide-1" ? (
                          <h className="pa"> P A POLYTECHNIC NADUPADAV MANGALORE</h>
                        ) : (
                          "P A POLYTECHNIC NADUPADAV MANGALORE"
                        )}
                      </div>
                    </div>
                    {/* <h1 className="college-name1">P A POLYTECHNIC</h1> */}
                    <div className="button-container">
                      <button 
                        className="apply-button" 
                        onClick={() => navigate(slide.id === "college-slide-1" ? "/contact" : "/apply")}
                      >
                        Apply Now
                      </button>
                      <button className="explore-button" onClick={() => navigate("/courses")}>
                        Explore Programs
                      </button>
                    </div>
                  </div>
                </SwiperSlide>
              );
            } 
            // Render placement image slide (check for imageUrl OR type === "placement")
            else if (slide.imageUrl) {
              return (
                <SwiperSlide key={slide.id} className="full-screen-slide">
                  <img 
                    src={slide.imageUrl} 
                    alt={`Placement ${index + 1}`} 
                    className="full-screen-image" 
                  />
                </SwiperSlide>
              );
            }
            return null;
          })
        ) : (
          <SwiperSlide className="full-screen-slide">
            <p className="no-image-text">No slides available.</p>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );
};

export default ViewPlacementImage;